import { render, staticRenderFns } from "./DocumentChildFilter.vue?vue&type=template&id=03cfae98&"
import script from "./DocumentChildFilter.vue?vue&type=script&lang=ts&"
export * from "./DocumentChildFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports